$.onmount('[data-toggle=order-filter]', function () {
  var $el = $(this)
  var $filtersSection = $('#filters-section')
  var $teaAddonsSection = $('#tea-addons-section')
  var $boxIdLabel = $('#box-id-label-text')
  var $boxIdTooltip = $('#box-id-tooltip')

  function toggleFilters() {
    // toggle filters section if the value is 'all_tea_addon_orders'
    if ($el.val() === 'all_tea_addon_orders') {
      $filtersSection.hide()
      $teaAddonsSection.show()
      $boxIdLabel.text('Box to pair with this 🍵 Tea Addon') // Change text to make sense for Tea Addons
      $boxIdTooltip.hide()
    } else {
      $filtersSection.show()
      $teaAddonsSection.hide()
      $boxIdLabel.text('Apply to ALL monthly orders') // Change text back to default
      $boxIdTooltip.show()
    }
  }

  // Initial state
  toggleFilters()

  // On change event
  $el.on('change', function () {
    toggleFilters()
  })
})
